import { useTranslate as useOriginalTranslate } from 'react-polyglot';
import { InterpolationOptions } from 'node-polyglot';
import { keys, Translations } from './keys';

type t = (phrase: string, options?: number | InterpolationOptions) => string;

const useTranslate: () => [t, Translations] = () => [useOriginalTranslate(), keys];

export default useTranslate;
